export default __webpack_public_path__ + "static/media/pac-3.991ae93c.png";